import AppSwitch from '@nxsys/components/AppSwitch';
import Inheritable from '@nxsys/components/Inheritable';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form, Switch } from 'antd';
import React from 'react';
import type { PayrollFinanceSectionProps } from './types';
import AppRateInput from '@nxsys/components/AppRateInput';

const TrackingSection: React.FC<PayrollFinanceSectionProps> = ({
  form,
  watchValues,
  visibility,
}) => {
  const { messages } = useTypedIntl();

  if (!visibility.tracking) return null;

  return (
    <div className="pt-6">
      <div className="mb-6 text-xl font-medium text-gray-800">
        {messages['common.tracking']}
      </div>
      <Form.Item
        label={messages['common.enableAWRTracking']}
        name={['tracking', 'enableAWRTracking']}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 4 }}
      >
        <AppSwitch />
      </Form.Item>
      <Form.Item name={['tracking', 'enableWTR']} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
        <Inheritable<boolean>
          label={messages['common.enableWorkingTimeRegulationTracking'] as string}
          name={['tracking', 'enableWTR']}
          value={watchValues?.tracking?.enableWTR}
          inheritedValue={false}
          form={form}
        >
          {({ value, onChange, disabled }) => (
            <Switch
              checked={value ?? false}
              disabled={disabled}
              onChange={onChange}
            />
          )}
        </Inheritable>
      </Form.Item>
      {watchValues?.tracking?.enableAWRTracking === true && (
        <Form.Item
          label={messages['common.notificationWeeks']}
          name={['tracking', 'notificationWeeks']}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
        >
          <AppRateInput placeholder={messages['form.enter']} />
        </Form.Item>
      )}
    </div>
  );
};

export default TrackingSection;
